module.exports = "//public.getcloudapp.com/packs/media/images/annotate/crop-117dcba6affffe1e3a255370efac6fd3.svg";